import { api } from 'services/api';

const patientSubscriptionService = api
  .enhanceEndpoints({
    addTagTypes: [
      'PatientSubscriptions',
      'PatientSubscriptionGroups',
      'BasketItems',
      'Subscriptions',
      'SubscriptionSettings',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      patientSubscriptionGroups: builder.query<
        ResultModel<PatientSubscriptionGroups>,
        PatientSubscriptionGroupsRequest
      >({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/get-patient-subscription-groups.json`,
          method: 'POST',
          body,
        }),
        providesTags: [{ type: 'PatientSubscriptionGroups', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      patientSubscription: builder.query<ResultModel<PatientSubscription>, PatientSubscriptionRequest>({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/get-patient-subscriptions.json`,
          method: 'POST',
          body,
        }),
        providesTags: [{ type: 'PatientSubscriptions', id: 'LIST' }],
        extraOptions: { isProfile: true },
      }),
      patientSubscriptionServices: builder.query<
        ResultModel<PatientSubscriptionServices>,
        PatientSubscriptionServicesRequest
      >({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/get-patient-subscription-services.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      patientSubscriptionServiceDetails: builder.query<
        ResultModel<PatientSubscriptionServiceDetails>,
        PatientSubscriptionServiceDetailsRequest
      >({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/get-patient-subscription-service-details.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
      deleteUnPaidSubscription: builder.mutation<ResultModel<void>, DeleteUnPaidSubscriptionRequest>({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/delete-unpaid-subscription.json`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [
          { type: 'BasketItems', id: 'LIST' },
          { type: 'Subscriptions', id: 'LIST' },
        ],
        extraOptions: { isProfile: true },
      }),
      createPatientSubscriptionCancellation: builder.mutation<
        ResultModel<void>,
        CreatePatientSubscriptionCancellationRequest
      >({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/create-patient-subscription-cancellation.json`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [
          { type: 'PatientSubscriptionGroups', id: 'LIST' },
          { type: 'PatientSubscriptions', id: 'LIST' },
          { type: 'SubscriptionSettings', id: 'LIST' },
        ],
        extraOptions: { isProfile: true },
      }),
      initiateChargeAttempt: builder.mutation<ResultModel<void>, InitiateChargeAttemptRequest>({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/initiate-charge-attempt.json`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [
          { type: 'PatientSubscriptionGroups', id: 'LIST' },
          { type: 'PatientSubscriptions', id: 'LIST' },
          { type: 'SubscriptionSettings', id: 'LIST' },
        ],
        extraOptions: { isProfile: true },
      }),
      changeMonthlySubscriptionCreditCard: builder.mutation<
        ResultModel<void>,
        ChangeMonthlySubscriptionCreditCardRequest
      >({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/change-monthly-subscription-credit-card.json`,
          method: 'POST',
          body,
        }),
        invalidatesTags: [
          { type: 'PatientSubscriptionGroups', id: 'LIST' },
          { type: 'PatientSubscriptions', id: 'LIST' },
          { type: 'SubscriptionSettings', id: 'LIST' },
        ],
        extraOptions: { isProfile: true },
      }),
      getSubscribedPatients: builder.query<
        ResultModel<GetSubscribedPatients>,
        GetSubscribedPatientsRequest
      >({
        query: (body) => ({
          url: `/443376B83AD6603D938A7A33A3622D99541F93A0/get-subscribed-patients.json`,
          method: 'POST',
          body,
        }),
        extraOptions: { isProfile: true },
      }),
    }),
  });

export const {
  usePatientSubscriptionGroupsQuery,
  usePatientSubscriptionQuery,
  usePatientSubscriptionServicesQuery,
  usePatientSubscriptionServiceDetailsQuery,
  useDeleteUnPaidSubscriptionMutation,
  useCreatePatientSubscriptionCancellationMutation,
  useInitiateChargeAttemptMutation,
  useChangeMonthlySubscriptionCreditCardMutation,
  useGetSubscribedPatientsQuery,
} = patientSubscriptionService;

